/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import useDebouncedCallback from "beautiful-react-hooks/useDebouncedCallback";
import { Button, Icon } from "semantic-ui-react";
import { useScanningContext } from "./scanning.provider";
import { useTranslation } from "react-i18next";
import { pulsing } from "../components/Shared/css/pulsing";

export const ScanFloatingButton = () => {
    const { displayScanButton,scanInProgress, startScan,stopScan } = useScanningContext()
    const [t] = useTranslation();

    const clickHandler = useDebouncedCallback(() => {
        if(scanInProgress){
            stopScan();
        }
        else{
            startScan();
        }
    },[scanInProgress,startScan,stopScan],200)

    if (!displayScanButton) {
        return null
    }

    return (
        <Button
            circular
            icon
            size="mini"
            color={scanInProgress ? "primary":"grey"}
            active={scanInProgress}
            onClick={clickHandler}
            css={css`
                &&& {
                    position: fixed;
                    bottom: 2rem;
                    right: 2rem;
                    z-index: 999;
                    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
                    transition: all 0.3s ease;
                    
                    &:hover {
                        transform: scale(1.1);
                        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.4);
                    }
                    
                    &:active {
                        transform: scale(0.95);
                    }
                    
                    i.icon {
                        font-size: 1.5rem;
                    }
                }
            `}
            aria-label={t('scanning.trigger_scan')}
        >
            <Icon name="barcode" />
        </Button>
    )
}